import clsx from 'clsx';

import classes from './mediaLightbox.module.css';

export type MediaLightboxEditActionsProps = {
  dataCy: string;
  saving: boolean;
  saveDisabled: boolean;
  onCancel: () => void;
  onSave: () => void;
};

const MediaLightboxEditActions = ({
  dataCy,
  saving,
  saveDisabled,
  onCancel,
  onSave,
}: MediaLightboxEditActionsProps) => (
  <div className={classes.editActions}>
    <button
      type="button"
      className={clsx(classes.editAction, classes.cancel)}
      disabled={saving}
      onClick={onCancel}
      data-cy={`${dataCy}CancelButton`}
    >
      Cancel
    </button>
    <button
      type="button"
      className={clsx(classes.editAction, classes.save)}
      disabled={saving || saveDisabled}
      onClick={onSave}
      data-cy={`${dataCy}SaveButton`}
    >
      {saving ? 'Saving' : 'Save'}
    </button>
  </div>
);

export default MediaLightboxEditActions;
